<!-- 判断题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select mb-10">
            <div class="topic_content scroll_x mar_left_10 flex-1">
                <div class="flex FlexBaseline">
                    <div>{{ subQuestionNum + 1 }}、</div>
                    <div class="topic_title" v-html="$Tools.handlerImg(topicInfo?.stem)" v-mathml></div>
                </div>
                <div>
                    <el-radio-group v-model="topicInfo.doAnswer" @change="changeAnswer">
                        <el-radio :value="true" size="large" :disabled="disabled">
                            <div class="flex Flexalign">
                                <div>对</div>
                            </div>
                        </el-radio>
                        <el-radio :value="false" size="large" :disabled="disabled">
                            <div class="flex Flexalign">
                                <div>错</div>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <!-- <div v-if="!testType">
            <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
                <div class="answer_top p-20">
                    <div>答题结果</div>
                    <div class="mt-20 flex FlexBetween">
                        <div>参考答案：<span class="correct_value_answer">{{
                            (topicInfo.answer == "true" || topicInfo.answer == "T") ? "对" : "错"
                                }}</span></div>
                        <div class="mar_left_20 user_answer" v-if="!hideUserAnswer">
                            你的答案：<span class="error_value_answer" :class="topicInfo.isCorrect == 1
                                ? 'correct_value_answer'
                                : ''
                                ">{{
                                    topicInfo.doAnswer ? (topicInfo.doAnswer == "true" ? "对" : "错") : '' }}</span>
                            <div class="bg_line"></div>
                        </div>
                        <div class="mar_left_20 flex">
                            <div class="full_score">
                                <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                                    v-if="topicInfo.isCorrect == 2"></el-image>
                                <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                                    v-if="topicInfo.isCorrect == 1"></el-image>
                            </div>
                            <div class="get_score ml-10" v-if="!hideUserAnswer">得分：{{ topicInfo.score || 0 }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div>
            <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
                <div class="answer_top p-20" v-if="getIsShow(1) || showAnswer">
                    <div>答题结果</div>
                    <div class="mt-20 flex FlexBetween">
                        <div>参考答案：<span class="correct_value_answer">{{
                            (topicInfo.answer == "true" || topicInfo.answer == "T") ? "对" : "错"
                                }}</span></div>
                        <div class="mar_left_20 user_answer" v-if="!hideUserAnswer">
                            你的答案：<span class="error_value_answer" :class="topicInfo.isCorrect == 1
                                ? 'correct_value_answer'
                                : ''
                                ">{{
                                    topicInfo.doAnswer ? (topicInfo.doAnswer == "true" ? "对" : "错") : '' }}</span>
                            <div class="bg_line"></div>
                        </div>
                        <div class="mar_left_20 flex">
                            <div class="full_score">
                                <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                                    v-if="topicInfo.isCorrect == 2"></el-image>
                                <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                                    v-if="topicInfo.isCorrect == 1"></el-image>
                            </div>
                            <div class="get_score ml-10" v-if="!hideUserAnswer">得分：{{ topicInfo.questionScore }}</div>
                        </div>
                    </div>
                    <!-- <div class="btn_ask">提问</div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "GjkcH5Choice",
    props: {
        questionInfo: {},
        disabled: {},
        subQuestionNum: {},
        isShowScoring: {
            default: false,
        },
        testType: {}, // 区分闯关，为1时是闯关,
    showAnswer:{}, // 用于测评报告弹题展示解析等
    },
    computed: {
        ...mapState({
            testExamTime: (state) => state.exam.testExamTime,
            testExamInfo: (state) => state.exam.testExamInfo,
        }),
    },

    data() {
        return {
            topicInfo: {},
        };
    },
    watch: {
        questionInfo: {
            handler(val) {
                if (val) {
                    this.topicInfo = this.questionInfo;
                    // 判断是否回答过
                    if (this.topicInfo.courseExamRecordId) {
                        // this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },

    mounted() { },

    methods: {
        getIsShow(showId) {
            let flag = false;
            if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
                if (!this.$Tools.empty(this.testExamInfo.otherRule.showAnswer)) {
                    if (this.testExamInfo.otherRule.showAnswer.findIndex(item => item == showId) != -1) {
                        flag = true;
                    }
                }
            }
            return flag
        },
        getChoiceLabel(value, options) {
            let label = "";
            options.forEach(item => {
                if (item.serial == value) {
                    label = item.label;
                }
            })
            return label;
        },
        changeAnswer(value) {
            this.topicInfo.doAnswer = value;
            if (value == this.topicInfo?.answer) {
                this.topicInfo.isCorrect = 1;
            } else {
                this.topicInfo.isCorrect = 2;
            }
            this.topicInfo.questionScore = (this.topicInfo.isCorrect == 1 ? this.topicInfo.score : 0); // 得分
            // this.topicInfo.questionContext.doAnswer = this.topicInfo.doAnswer;   // 保存答案
            // this.topicInfo.questionContext.isFinish = true;   // 是否已完成
            this.$emit('answerQuestion', this.topicInfo);
        }
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    .topic_type {
        // margin-top: 1rem;
        min-width: 45px;
        padding: 0 8px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {
        // overflow-x: auto;

        .topic_title {
            font-size: 16px;
            color: #242324;
            font-weight: 600;
        }
    }
}

.bottom_box {
    position: absolute;
    left: calc(50% - 60px);
    bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
    }

    .view_analysis {
        color: #13D6AA;
    }
}

.topic_answer {
    width: 100%;
    // height: 222px;
    // background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    // padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .answer_top {
        background: #F8F9FA;
        border-radius: 8px;
        width: 100%;
        box-sizing: border-box;

        .user_answer {
            position: relative;

            .bg_line {
                width: 73px;
                height: 8px;
                background: rgba(19, 214, 170, 0.2);
                position: absolute;
                bottom: 6px;
                left: 0;
            }
        }

        .question_error_icon {
            width: 26px;
            height: 26px;
        }

        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }

        .get_score {
            color: #FD673B;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}
</style>